import styled from "styled-components";
import media from "constants/media";

export const Logos = styled.ul`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-top: 25px;

    list-style: none;
`;

export const Logo = styled.li`
    width: 33.3%;
    margin-bottom: 20px;

    text-align: center;

    ${media.mdUp`
        margin-bottom: 25px;
    `}
`;

export const Icon = styled.img`
    width: 100%;
    max-width: 90px;
    max-height: 15px;

    ${media.mdUp`
        max-width: 160px;
        max-height: 25px;
    `}
`;
